export default "__VITE_ASSET__eMPej_A5__";